// extracted by css-extract-rspack-plugin
export default {"shield":"DoubleClickShield_shield__YKPgp"};